export const SHEET_SELECTION_VIEW_MODE = 'SHEET_SELECTION_VIEW_MODE';
export const SHEET_SELECTION_SELECTED_SPREAD_SHEET =
  'SHEET_SELECTION_SELECTED_SPREAD_SHEET';
export const SHEET_SELECTION_SELECTING_SPREADSHEET_PAGE_INDEX =
  'SHEET_SELECTION_SELECTING_SPREADSHEET_PAGE_INDEX';
export enum ViewTemplate {
  GRID = 'GRID',
  LIST = 'LIST',
}
